import React from 'react';

interface CTAProps {
  onCtaClick: () => void;
}

const CTASection: React.FC<CTAProps> = ({ onCtaClick }) => {
  const studentPhotos = [
    "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=400",
    "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&q=80&w=400",
    "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&q=80&w=400",
    "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&q=80&w=400"
  ];

  return (
    <div className="py-24 bg-[#FAF7F2] text-slate-800 relative overflow-hidden border-t border-[#F2ECE4]">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/4 h-full bg-pink-100/10 -skew-x-12 transform translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-1/4 h-full bg-pink-100/5 skew-x-12 transform -translate-x-1/2"></div>
      
      <div className="max-w-7xl mx-auto px-4 relative z-10 text-center">
        {/* Student Study Photos Row */}
        <div className="flex flex-wrap justify-center gap-6 mb-16">
          {studentPhotos.map((src, i) => (
            <div key={i} className="w-32 h-32 md:w-44 md:h-44 rounded-[2.5rem] overflow-hidden border-2 border-white shadow-xl transform hover:rotate-1 hover:scale-105 transition-all duration-300 bg-white">
               <img src={src} alt={`Student ${i}`} className="w-full h-full object-cover grayscale-[10%] hover:grayscale-0" />
            </div>
          ))}
        </div>

        <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight max-w-4xl mx-auto text-slate-900">
          더 이상 미루지 마세요. <br/>
          당신의 영어는 <span className="text-pink-300 underline decoration-pink-100 underline-offset-8">30회 전과 후</span>로 나뉩니다.
        </h2>
        
        <p className="text-slate-500 text-xl mb-12 max-w-2xl mx-auto font-medium opacity-90">
          지금 신청하시면 '토플 80점 돌파를 위한 영역별 AI 핵심 전략 가이드북'을 100% 무료로 드립니다.
        </p>

        <button 
          onClick={onCtaClick}
          className="bg-pink-300 text-white px-10 py-5 rounded-full font-black text-xl hover:bg-pink-400 transition-all shadow-xl hover:scale-105 active:scale-95"
        >
          무료 AI 레벨 테스트 & 상담 시작하기
        </button>
      </div>
    </div>
  );
};

export default CTASection;